import React from 'react';
import { formatDate } from '../../utilities/dateTimeUtils';
import { Icon } from '../Icon';
import { DatePickerInputProps } from '.';
import { ButtonWrapper, DatePickerTextField, ErrorText } from './styles';
import Colors from '../../theme/colors';

function DatePickerInput({ value, onClick, id, error }: DatePickerInputProps) {
  const dateValue = formatDate(value) ?? 'Select Date';
  const iconVariant = value ? 'active' : 'default';
  return (
    <>
      <ButtonWrapper onClick={onClick} disableRipple>
        <DatePickerTextField
          label={id}
          variant="standard"
          value={dateValue}
          disabled
          InputProps={{
            style: {
              pointerEvents: 'none',
              borderBottom: error ? `1px solid ${Colors.Status.Error}` : undefined,
            },
            endAdornment: <Icon name="event" variant={iconVariant} />,
            inputProps: {
              style: {
                color: value ? Colors.Text.Paragraph : Colors.Text.Default,
                WebkitTextFillColor: value ? Colors.Text.Paragraph : Colors.Text.Default,
              },
            },
          }}
        />
      </ButtonWrapper>
      {error ? (
        <ErrorText color={Colors.Status.Error} variant="BodySmallRegular">
          {error}
        </ErrorText>
      ) : null}
    </>
  );
}

export default DatePickerInput;
